import React, { FC } from 'react';
import { Link } from 'gatsby';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

const Root = styled('footer')({
  paddingTop: 40,
  paddingBottom: 40,
});

const Description = styled(Typography)({
  fontSize: 15,
  margin: "16px 0",
  color: '#000000',
});

const Logo = styled('img')({
  width: 196,
  height: 17,
});

const IconWrapper = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  display: 'flex',
  paddingInlineStart: 0,
  [theme.breakpoints.down('md')]: {
    '& li': {
      display: 'flex',
      flex: 1,
    },
  },
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'flex-end',
    '& li': {
      width: 40,
      display: 'block',
      marginRight: 40,
    },
    '& li:last-child': {
      marginRight: 0,
    },
  },
}));

const TermsContainer = styled('div')({
  display: 'inline-block',
});
const linkBaseStyle = {
  color: '#444444',
  fontSize: '14px',
}
const PrivacyPolicy = styled(Link)({
  ...linkBaseStyle,
  fontWeight: 700
});

const TermsDivider = styled('span')({
  ...linkBaseStyle,
  padding: '0 8px',
});

const TermsExternalLink = styled('a')(linkBaseStyle)
const TermsInternalLink = styled(Link)(linkBaseStyle)

const Icon = styled('img')({
  width: 40,
  height: 40,
});

const SNSContainer = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
})

const links = [
  {
    icon: '/icons/facebook.svg',
    link: 'https://www.facebook.com/hpcnt',
    alt: 'facebook',
  },
  {
    icon: '/icons/linkedin.svg',
    link: 'https://www.linkedin.com/company/hyperconnect/',
    alt: 'linkedin',
  },
  {
    icon: '/icons/instagram.svg',
    link: 'https://www.instagram.com/hyperconnect/',
    alt: 'instagram',
  },
  {
    icon: '/icons/btn-tech-blog.svg',
    link: 'https://hyperconnect.github.io/',
    alt: 'tech blog',
  },
];

const Footer: FC = () => (
  <Root>
    <Container>
      <Grid container justifyContent="space-between">
        <Grid item xs={12} sm={6}>
          <Logo src="/logos/CI.svg" alt="hyperconnect" />
          <Description>Copyright © 2023, HYPERCONNECT LLC. All rights reserved</Description>
          <TermsContainer>
          <PrivacyPolicy to="/privacy">개인정보 처리방침</PrivacyPolicy>
          <TermsDivider>|</TermsDivider>
          <TermsInternalLink to='/terms/cookie-policy.html'>쿠키정책</TermsInternalLink>
          <TermsDivider>|</TermsDivider>
          <TermsExternalLink onClick={() => window.OneTrust?.ToggleInfoDisplay()}>쿠키설정</TermsExternalLink>
          </TermsContainer>
        </Grid>

        <SNSContainer item xs={12} sm={6}>
          <IconWrapper>
            {links.map(item => (
              <li key={item.link}>
                <a href={item.link}>
                  <Icon src={item.icon} alt={item.alt} />
                </a>
              </li>
            ))}
          </IconWrapper>
        </SNSContainer>
      </Grid>
    </Container>
  </Root>
);

export default Footer;
